
import { Injectable } from '@angular/core';
import { AlertService } from '../../../../app/services/alert/alert.service';
import { ApiConnectionService } from '../../../../app/services/api/apiconnection.service';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    constructor(
        private apiConnect: ApiConnectionService,
        private alertService: AlertService,
    ) {
    }

    saveRole(link: string, form: any, onSave: (res?: any, status?: boolean) => void, queryParam?: any, id?: any): void {
        this.apiConnect.callApi(link, 'Role', form, queryParam, id)
            .subscribe(
                (res: any) => {
                    onSave(res.data, true);
                    if (link !== 'GET') {
                        this.alertService.setAlert({
                            type: 'success',
                            title: 'Success',
                            code: res.status,
                            message: res.message,
                        });
                    }
                },
                (err: any) => {
                    onSave(err, false);
                    this.alertService.setAlert({
                        type: 'danger',
                        title: 'Error',
                        code: err.status,
                        message:   err.message.error.error,
                    });
                }
            );
    }

    updatePermissions(form: any, onSave: (res?: any, status?: boolean) => void, queryParam?: any, id?: any): void {
        this.apiConnect.callApi('PUT', 'UpdateRolePermission', form, queryParam, id)
            .subscribe(
                (res: any) => {
                    onSave(res.data, true);
                    this.alertService.setAlert({
                        type: 'success',
                        title: 'Success',
                        code: res.status,
                        message: res.message,
                    });
                },
                (err: any) => {
                    onSave(err, false);
                    this.alertService.setAlert({
                        type: 'danger',
                        title: 'Error',
                        code: err.status,
                        message:   err.message.error.error,
                    });
                }
            );
    }

    updateCategoryPermission(form: any, onSave: (res?: any, status?: boolean) => void, queryParam?: any, id?: any): void {
        this.apiConnect.callApi('PUT', 'UpdateCategoryPermission', form, queryParam, id)
            .subscribe(
                (res: any) => {
                    onSave(res.data, true);
                    this.alertService.setAlert({
                        type: 'success',
                        title: 'Success',
                        code: res.status,
                        message: res.message,
                    });
                },
                (err: any) => {
                    onSave(err, false);
                    this.alertService.setAlert({
                        type: 'danger',
                        title: 'Error',
                        code: err.status,
                        message:   err.message.error.error,
                    });
                }
            );
    }

    updateCategoryItemPermission(form: any, onSave: (res?: any, status?: boolean) => void, queryParam?: any, id?: any): void {
        this.apiConnect.callApi('PUT', 'UpdateCategoryItemPermission', form, queryParam, id)
            .subscribe(
                (res: any) => {
                    onSave(res.data, true);
                    this.alertService.setAlert({
                        type: 'success',
                        title: 'Success',
                        code: res.status,
                        message: res.message,
                    });
                },
                (err: any) => {
                    onSave(err, false);
                    this.alertService.setAlert({
                        type: 'danger',
                        title: 'Error',
                        code: err.status,
                        message:   err.message.error.error,
                    });
                }
            );
    }

    updateCategoryPrivilegePermission(form: any, onSave: (res?: any, status?: boolean) => void, queryParam?: any, id?: any): void {
        this.apiConnect.callApi('PUT', 'UpdateCategoryPrivilegePermission', form, queryParam, id)
            .subscribe(
                (res: any) => {
                    onSave(res.data, true);
                    this.alertService.setAlert({
                        type: 'success',
                        title: 'Success',
                        code: res.status,
                        message: res.message,
                    });
                },
                (err: any) => {
                    onSave(err, false);
                    this.alertService.setAlert({
                        type: 'danger',
                        title: 'Error',
                        code: err.status,
                        message:   err.message.error.error,
                    });
                }
            );
    }

}
